import { DataBean } from "../DataBean";

export class ExportAccountList extends DataBean {



    public async exportAccountList(regexStr: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportAccountList_String", [regexStr]);
    }

}